import moment from 'moment';

import * as dto from 'client/dto';
import { TargetVaccinationDateStatus } from 'utils/dateTimeHelpers';

import { ProjGraphLineData } from 'components/_graphs/BdProjectionGraph/BdProjectionGraph';

import { ReopeningTrackerTrends } from './components/ReopeningTracker/cell/ReopeningTrackerTrendStatement';

export type ReopeningTrackerCellType = 'stringency' | 'total-pop' | 'case-level';
export type ReopeningTrackerDataSetType = 'high-risk' | 'stringency' | 'total-pop' | 'case-level';

export const StartDateCell = moment().subtract(3, 'months').startOf('day').toDate();

export type VaccineLocationRow = {
  id: number;
  name: string;
  displayName: string;
  provinceName: string;
  countryName: string;
  locationType: dto.LocationType;
  stringency: VaccineTrackerCellData;
  totalAdult: VaccineTrackerCellData;
  caseLevels: VaccineTrackerCellData;
  casesMaxYValue: number;
};

export type VaccineTrackerCellData = {
  data: dto.LocationVaccinationRateModel;
  secondaryData?: VaccineTrackerCellData;
  isProjectionReliable: boolean;
  hasAchievedMilestone: boolean;
  latestUpdateDate: Date;
  latestUpdateCasesDate: Date;
  latestUpdateTestsDate: Date;
  latestUpdateStringencyDate: Date;
  milestoneStatus: TargetVaccinationDateStatus;
  graphHasData: boolean;
  historicalData: ProjGraphLineData[];
  projectedData: ProjGraphLineData[];
  summary: ReopeningTrackerTrendSummary;
};

export type ReopeningTrackerTrendSummary = {
  type: ReopeningTrackerTrends;
  text: string;
};
